import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-continue-reset',
  templateUrl: './continue-reset.page.html',
  styleUrls: ['./continue-reset.page.scss'],
})
export class ContinueResetPage implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onClose = (accept: boolean) => this.modalCtrl.dismiss(accept);

}
